import Vue from "vue";
import Vuex from "vuex";
import meteorologySdk from "../components/swqx/store/meteorologySdk.js";
import meteorological from "../components/swqx/store/meteorological.js";
import gale from "../components/swqx/store/gale.js";
import fishArea from "../components/swqx/store/FishArea.js";
import fishGround from "../components/swqx/store/FishGround.js";
import seaArea from "../components/swqx/store/SeaArea.js";
import tideForecast from "../components/swqx/store/TideForecast.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    map: undefined,
    token: undefined,
    appNum: undefined,
    reqId: undefined,
    source: undefined,
    version: undefined,
    ip: undefined,
  },
  mutations: {
    setMap(state, map) {
      state.map = map;
    },
    setToken(state, token) {
      state.token = token;
    },
    setAppNum(state, appNum) {
      state.appNum = appNum;
    },
    setReqId(state, reqId) {
      state.reqId = reqId;
    },
    setSource(state, source) {
      state.source = source;
    },
    setVersion(state, version) {
      state.version = version;
    },
    setIp(state, ip) {
      state.ip = ip;
    },
  },
  actions: {},
  modules: {
    meteorologySdk,
    meteorological,
    gale,
    fishArea,
    fishGround,
    seaArea,
    tideForecast,
  },
});

export default store;
